import React from 'react';
import { CheckIcon, GlobeIcon, TrophyIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcitySpots } from './ScarcitySpots';
const stack = [{
  emoji: '📘',
  title: 'Aligner Treatment Blueprint™',
  detail: '6 premium volumes',
  value: '$97'
}, {
  emoji: '🎁',
  title: '5 professional bonuses',
  detail: 'Cards · Trackers · Setup · Refinement · Clinical Desk',
  value: '$167'
}, {
  emoji: '📋',
  title: '30+ planning tools',
  detail: 'Frameworks · Checklists · Trackers · Maps · Worksheets · Quick references',
  value: '$67'
}];
const guarantees = ['One-time payment', 'Lifetime access', 'No monthly fees', 'Instant digital access'];
export function OfferSection() {
  return <section id="offer" className="bg-navy px-4 py-14 sm:px-6 sm:py-20" data-id="element-173" data-mp="2t6kxc5ssu6rr">
      <div className="mx-auto w-full max-w-2xl" data-id="element-174" data-mp="2y3uk1dot04bw">
        <p className="flex items-center justify-center gap-2 text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-sky" data-id="element-175" data-mp="2y4mdahuxhpz0">
          <TrophyIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-176" data-mp="xws3xwzyvoti" />
          Special launch offer
        </p>

        <h2 className="mt-4 text-center text-[26px] font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-177" data-mp="sxfingoqupt1">
          Here’s everything you’ll get today
        </h2>

        <ul className="mt-9 space-y-3" data-id="element-178" data-mp="ouakfqbp5aa7">
          {stack.map(item => <li key={item.title} className="flex items-center gap-3.5 rounded-2xl border border-white/15 bg-white/5 p-4" data-id="element-179" data-mp="1lll6icb3gux3">
              <span className="text-2xl" aria-hidden="true" data-id="element-180" data-mp="1ckwoz7mhscfg">
                {item.emoji}
              </span>
              <div className="min-w-0 flex-1" data-id="element-181" data-mp="17ltlhrm5ue9l">
                <p className="text-[14.5px] font-black uppercase leading-tight text-white sm:text-base" data-id="element-182" data-mp="17oy07ix94sei">
                  {item.title}
                </p>
                <p className="mt-1 text-[12px] leading-snug text-white/70 sm:text-[13px]" data-id="element-183" data-mp="3sc16pu38punx">
                  {item.detail}
                </p>
              </div>
              <span className="shrink-0 text-[13px] font-extrabold text-sky sm:text-[15px]" data-id="element-184" data-mp="2ngbgd5ixuhz">
                {item.value}
              </span>
            </li>)}
        </ul>

        <div className="mt-8 rounded-3xl bg-white p-6 text-center shadow-2xl shadow-black/20 sm:p-9" data-id="element-185" data-mp="3ouwkcgqofucj">
          <p className="text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-navy2/70" data-id="element-186" data-mp="3b3hze4d7lj2u">
            Total perceived value
          </p>
          <p className="mt-1 text-3xl font-black text-navy2/50 line-through sm:text-4xl" data-id="element-187" data-mp="3fv0515q6g7u5">
            $331
          </p>

          <p className="mt-6 text-[12.5px] font-extrabold uppercase tracking-[0.16em] text-navy" data-id="element-188" data-mp="31759lhksbpdd">
            Today you can get everything for just
          </p>
          <p className="mt-2 text-[68px] font-black leading-none text-cta sm:text-8xl" data-id="element-189" data-mp="2s4dy5hrwstlq">
            $27
          </p>

          <ul className="mx-auto mt-6 grid max-w-sm grid-cols-2 gap-2" data-id="element-190" data-mp="2x2fh82pc4sx7">
            {guarantees.map(item => <li key={item} className="flex items-center gap-2 rounded-xl bg-skysoft px-2.5 py-2 text-left" data-id="element-191" data-mp="2di71wwiqluwr">
                <CheckIcon className="h-3.5 w-3.5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-192" data-mp="2mivgbsc1lxa6" />
                <span className="text-[11.5px] font-bold leading-tight text-navy" data-id="element-193" data-mp="2wgjdsq119iw1">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="mx-auto mt-6 flex max-w-sm items-start gap-2 rounded-xl border border-navy/10 bg-cream px-3.5 py-3 text-left text-[12px] leading-snug text-navy2 sm:text-[13px]" data-id="element-194" data-mp="2rfvoc8sgda3x">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-195" data-mp="318b36x8gdikl" />
            <span data-id="element-196" data-mp="3a87l8g0c7j6o">
              <strong className="font-extrabold text-navy" data-id="element-197" data-mp="3a8pqu38w39r9">
                Automatic currency conversion:
              </strong>{' '}
              the $27 price is converted to your local currency at checkout, so
              you pay in the currency of your country.
            </span>
          </p>

          <p className="mt-6 text-[13.5px] leading-relaxed text-navy2 sm:text-[15px]" data-id="element-198" data-mp="1i8lbn2x0cp4z">
            For less than the cost of a typical professional lunch, you’ll have
            a structured digital system you can return to whenever you need to
            organize and review an aligner case.
          </p>

          <div className="mt-7" data-id="element-199" data-mp="ukai6ktn5rqq">
            <CtaButton label="Get Aligner Treatment Blueprint™" subLabel="One-time payment of $27 · Instant digital access · 7-day guarantee" data-id="element-200" data-mp="ujiudw6acyb0" />
          </div>

          <div className="mt-7" data-id="element-201" data-mp="13l8lf0w99v89">
            <ScarcitySpots data-id="element-202" data-mp="2a09kvgkhovjl" />
          </div>
        </div>

        <div className="mt-9" data-id="element-203" data-mp="29zrhlzzeth26">
          <Countdown tone="dark" data-id="element-204" data-mp="2ez424e2t6c1l" />
        </div>
      </div>
    </section>;
}